export default "__VITE_ASSET__CWEKuUzb__"